// Remembers where to send the user after they sign in — used by the AI-connector consent page
// (/oauth/consent), which an AI app like Claude opens while the user may be signed out.
// sessionStorage survives the Google OAuth round-trip within the same tab. Only internal
// /oauth/consent paths are accepted, so this can't become an open redirect.
const KEY = "flow_post_login_redirect";
const ALLOWED_PREFIX = "/oauth/consent";

export function rememberPostLoginRedirect(path) {
    try {
        if (path?.startsWith(ALLOWED_PREFIX)) sessionStorage.setItem(KEY, path);
    } catch { /* storage blocked — user just lands on the dashboard */ }
}

// Read-only (safe to call during render, incl. React StrictMode double renders).
export function peekPostLoginRedirect() {
    try {
        const path = sessionStorage.getItem(KEY);
        return path?.startsWith(ALLOWED_PREFIX) ? path : null;
    } catch {
        return null;
    }
}

// Called by the consent page once it has actually opened.
export function clearPostLoginRedirect() {
    try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
